'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Notification = require('./Notification');

var _Notification2 = _interopRequireDefault(_Notification);

var _store = require('./lib/store');

var _store2 = _interopRequireDefault(_store);

var _NotificationActions = require('./lib/NotificationActions');

var _NotificationActions2 = _interopRequireDefault(_NotificationActions);

var _reactFlipMove = require('react-flip-move');

var _reactFlipMove2 = _interopRequireDefault(_reactFlipMove);

var _constants = require('./lib/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The notification container is used for rendering notifications in your web
 * application. All notifications added to the system will be children of this container.
 * Additionally it handles all notification animations with the help
 * of react-flip-move (https://github.com/joshwcomeau/react-flip-move). Documentation for
 * prop types is taken from react-flip-move, since they are only passed to the flip move component.
 * 
 * The container itself is a fixed div container with a z-index of 1200.
 * 
 * @author Timo Hanisch <timohanisch@googlemail.com>
 * @since 0.1.0
 */
var NotificationContainer = function (_React$Component) {
    _inherits(NotificationContainer, _React$Component);

    function NotificationContainer() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, NotificationContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationContainer.__proto__ || Object.getPrototypeOf(NotificationContainer)).call.apply(_ref, [this].concat(args))), _this), _this._onNotificationClose = function (notificationId) {
            _NotificationActions2.default.removeNotification(notificationId);
        }, _this._onStoreUpdate = function () {
            _this.forceUpdate();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /**
     * The default enter/appear animation used by notifications added to
     * the notification container.
     * 
     * @private
     */


    /**
     * The default leave animation used by notifications added to
     * the notification container.
     * 
     * @private
     */


    _createClass(NotificationContainer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            _store2.default.on(_constants.DISPATCH_UPDATE, this._onStoreUpdate);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // When the container unmounts we want all old notifications to be cleared.
            // Currently only one NotificationContainer at a time is supported.
            _NotificationActions2.default.resetNotifications();
            _store2.default.removeListener(_constants.DISPATCH_UPDATE, this._onStoreUpdate);
        }

        /**
         * Callback for the close button.
         * 
         * @param {Number} notificationId Id of the notification to be removed
         * @private
         */


        /**
         * Called when the internal notification store is updated. I.e. a notifcation is added
         * or removed.
         * 
         * @private
         */

    }, {
        key: '_builContainerStyle',


        /**
         * Builds the notficiaton container style with help of the passed position property.
         * 
         * @private
         * @returns a style object used for the notification container itself.
         */
        value: function _builContainerStyle() {
            var position = this.props.position;
            // Depending on the chosen position we use a margin of 32 pixels from the
            // corresponding side.

            return _extends({}, NotificationContainer.STYLE.container, {
                bottom: position.indexOf('bottom') !== -1 && 32,
                left: position.indexOf('left') !== -1 && 32,
                right: position.indexOf('right') !== -1 && 32,
                top: position.indexOf('top') !== -1 && 32
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                appearAnimation = _props.appearAnimation,
                duration = _props.duration,
                easing = _props.easing,
                enterAnimation = _props.enterAnimation,
                leaveAnimation = _props.leaveAnimation;
            // Retrieve the notifcations from the internal store

            var notifications = _store2.default.notifications;
            return _react2.default.createElement(
                _reactFlipMove2.default,
                {
                    appearAnimation: appearAnimation,
                    duration: duration,
                    easing: easing,
                    enterAnimation: enterAnimation,
                    leaveAnimation: leaveAnimation,
                    style: this._builContainerStyle()
                },
                notifications.map(function (notification, index) {
                    return _react2.default.createElement(_Notification2.default, {
                        key: notification.id,
                        headerLabel: notification.headerLabel,
                        onClose: function onClose() {
                            return _this2._onNotificationClose(notification.id);
                        },
                        title: notification.title,
                        text: notification.text,
                        avatar: notification.avatar,
                        actions: notification.actions,
                        icon: notification.icon,
                        primaryColor: notification.primaryColor,
                        secondaryHeaderLabel: notification.secondaryHeaderLabel,
                        timestamp: notification.timestamp,
                        style: _extends({ marginTop: index > 0 ? 16 : 0 }, notification.style)
                    });
                })
            );
        }
    }]);

    return NotificationContainer;
}(_react2.default.Component);

NotificationContainer._enterAnimation = {
    from: {
        opacity: 0.25
    },
    to: {
        opacity: 1
    }
};
NotificationContainer._leaveAnimation = {
    from: {
        opacity: 1
    },
    to: {
        opacity: 0
    }
};
NotificationContainer.propTypes = {
    /**
     * Control the appear animation that runs when the component mounts. Control the appear 
     * animation that runs when the component mounts. Works identically to enterAnimation below, 
     * but only fires on the initial children.
     */
    appearAnimation: _propTypes2.default.oneOfType([_propTypes2.default.shape({
        from: _propTypes2.default.object,
        to: _propTypes2.default.object
    }), _propTypes2.default.oneOf(['elevator', 'fade', 'accordionVertical', 'accordionHorizontal', 'none']), _propTypes2.default.bool]),

    /**
     * The length, in milliseconds, that the transition ought to take.
     */
    duration: _propTypes2.default.number,

    /**
     * Any valid CSS3 timing function (eg. "linear", "ease-in", "cubic-bezier(1, 0, 0, 1)").
     */
    easing: _propTypes2.default.string,

    /**
     * Control the onEnter animation that runs when new notifcations are added to the container.
     */
    enterAnimation: _propTypes2.default.oneOfType([_propTypes2.default.shape({
        from: _propTypes2.default.object,
        to: _propTypes2.default.object
    }), _propTypes2.default.oneOf(['elevator', 'fade', 'accordionVertical', 'accordionHorizontal', 'none']), _propTypes2.default.bool]),

    /**
     * Control the onLeave animation that runs when new notifications are removed from the container.
     */
    leaveAnimation: _propTypes2.default.oneOfType([_propTypes2.default.shape({
        from: _propTypes2.default.object,
        to: _propTypes2.default.object
    }), _propTypes2.default.oneOf(['elevator', 'fade', 'accordionVertical', 'accordionHorizontal', 'none']), _propTypes2.default.bool]),

    /* The position of the container relativly to the browser view */
    position: _propTypes2.default.oneOf(['top-left', 'top-right', 'bottom-right', 'bottom-left'])
};
NotificationContainer.defaultProps = {
    appearAnimation: NotificationContainer._enterAnimation,
    duration: 350,
    easing: 'cubic-bezier(0.23, 1, 0.32, 1)',
    enterAnimation: NotificationContainer._enterAnimation,
    leaveAnimation: NotificationContainer._leaveAnimation,
    position: 'top-right'
};
NotificationContainer.STYLE = {
    container: {
        position: 'fixed',
        zIndex: 1200,
        minWidth: 320
    }
};
exports.default = NotificationContainer;
module.exports = exports['default'];